import type { LucideIcon } from "lucide-react";
import {
  CircleHelpIcon,
  GlobeIcon,
  HardDriveIcon,
  SettingsIcon,
  SlidersHorizontalIcon,
  UserIcon,
} from "lucide-react";

export type SettingsPage = {
  path: string;
  label: string;
  icon: LucideIcon;
  keywords: string[];
};

export const settingsPages = [
  {
    path: "/settings/general",
    label: "General",
    icon: SettingsIcon,
    keywords: ["rename", "prompt", "files", "behavior"],
  },
  {
    path: "/settings/account",
    label: "Account",
    icon: UserIcon,
    keywords: ["user", "profile", "sign in", "sign out", "login", "logout"],
  },
  {
    path: "/settings/services",
    label: "Services",
    icon: GlobeIcon,
    keywords: [
      "api",
      "key",
      "credentials",
      "blast",
      "genbank",
      "ncbi",
      "interpro",
      "interproscan",
      "domain",
      "protein",
      "ebi",
      "email",
    ],
  },
  {
    path: "/settings/storage",
    label: "Storage",
    icon: HardDriveIcon,
    keywords: ["disk", "space", "limit", "usage", "quota"],
  },
  {
    path: "/settings/viewers",
    label: "Viewers",
    icon: SlidersHorizontalIcon,
    keywords: ["display", "tracks", "sequence", "msa", "defaults"],
  },
  {
    path: "/settings/help",
    label: "Help",
    icon: CircleHelpIcon,
    keywords: ["help", "completion", "tracking", "progress", "features"],
  },
] as const satisfies readonly SettingsPage[];
